import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import { NitroIcon, NitroText } from "nitro-components";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

const AlertSection = styled.div`
& .background-enter {
  transform: translate(100%);
}
& .background-enter.background-enter-active {
  transform: translate(0%);
  transition: transform 1000ms ease-in-out;
}
& .background-leave {
  transform: translate(0%);
}
.background-leave.background-leave-active {
  transform: translate(-100%);
  transition: transform 1000ms ease-in-out;
}

& .background-appear {
  transform: translate(100%);
}

& .background-appear.background-appear-active {
  transform: translate(0%);
  transition: transform 800ms ease-in-out;
}
`;

const AlertContainer = styled.div`
position:absolute;
top:24px;
right:20px;
//animation: slide-from-right 0.7s linear;
//animation-iteration-count: 1;
opacity: 1;
`;

const AlertBadge = styled.div`
box-shadow: 0 4px 15px 0 rgba(0,0,0,0.15);
width: 100%;
height: 50px;
padding:15px;
display: flex;
justify-content: center; /* align horizontal */
align-items: center; /* align vertical */
border-radius: 100px;
margin: 0 auto;
background-color: ${props => props.theme.color.negative};
animation: alertPulse 1.8s ease-out;
animation-iteration-count: infinite;
`;

const MinimalAlertBadge = styled.button`
  backface-visibility: hidden;
  background-color: ${props => props.theme.color.negative};
  border-radius: 100%;
  border: 0;
  box-shadow: 0 4px 15px 0 rgba(0,0,0,0.15);
  height: 35px;
  outline: 0;
  padding: 0;
  text-align:center;
	transform: scale(1);
	transition: transform .3s;
  width: 35px;

	&:hover {
	  transform: scale(1.1);
	}

	&:focus {
		outline: 0;
	}
`;

const HeaderAlert = props => {
	if (props.minimal)
		return (
			<MinimalAlertBadge>
				<NitroIcon
					name="declined"
					variant="white"
					size={16}
					bottom={7}
				/>
			</MinimalAlertBadge>
		);
	else
		return (
			<AlertSection>
				<ReactCSSTransitionGroup
					transitionName="background"
					transitionEnterTimeout={1000}
					transitionLeaveTimeout={1000}
					transitionAppear={true}
					transitionAppearTimeout={500}
				>
					<AlertContainer>
						<AlertBadge>
							{(props.dashboardType === 'driver') ? <NitroIcon
								name="declined"
								variant="white"
								size={16}
								right={10}
								bottom={3}
							/> :

							<NitroIcon
								name="solid-red-warning"
								size={20}
								right={10}
								
							/> }

							<NitroText size={12} bold variant="white">
								{props.content}
							</NitroText>
						</AlertBadge>
					</AlertContainer>
				</ReactCSSTransitionGroup>
			</AlertSection>
		);
};

HeaderAlert.propTypes = {
	content: PropTypes.string,
	minimal: PropTypes.bool,
	dashboardType: PropTypes.string
};

HeaderAlert.defaultProps = {
	minimal: false
};

export default HeaderAlert;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/HeaderAlert.js